module.exports = {
    methods: {
        validateEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            this.emailValid = re.test(email);
          },
          pwdLenth() {
            if (this.password.length >= 8) {
              this.pwd = true;
            } else {
              this.pwd = false;
            }
            // console.log("password length", this.pwd);
          },
          swalSuccess() {
            swal({
              icon: "success",
              title: "Successfully Added",
              text: "Login details sent on an email",
              dangerMode: false,
            });
          },
          swalDeviceSuccess() {
            swal({
              icon: "success",
              title: "Success",
              text: "Device info updated",
              dangerMode: false,
            });
          },
          swalHistSuccess() {
            swal({
              icon: "success",
              title: "Success",
              text: "History cleared.",
              dangerMode: false,
            });
          },
          swalError() {
            swal({
              title: "Error",
              text: "Please fill all the required fields",
              icon: "error",
              dangerMode: true,
            });
          },
          swalEmailError() {
            swal({
              title: "Error",
              text: "Please enter a valid email address",
              icon: "error",
              dangerMode: true,
            });
          },
          swalPwdError() {
            swal({
              title: "Error",
              text: "Password needs to have minimum 8 characters",
              icon: "error",
              dangerMode: true,
            });
          },
          swalNetworkError() {
            swal({
              title: "Error",
              text: "Something went wrong during update",
              icon: "error",
              dangerMode: true,
            });
          },
          swalLimitUpdateSuccess() {
            swal({
              icon: "success",
              title: "Call Limit Updated",
              text: "Call Limit has been updated for the user",
              dangerMode: false,
            });
          },
          swalLimitError() {
            swal({
              title: "Error",
              text: "The limit is less than 100",
              icon: "error",
              dangerMode: true,
            });
          },
          swalSearchError() {
            swal({
              title: "Error",
              text: "Please enter valid key or email ID",
              icon: "error",
              dangerMode: true,
            });
          },

}
}